export default {
    'host': 'app.safee.com.au',
    'port': null,
    'contextRoot': '/',
    'protocol': 'https'
};
